<template>
  <transition name="fade">
    <div v-if="visible" class="toast" :class="[type]" :style="computedStyle">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    message: String,
    type: {
      type: String,
      default: 'success'
    },
    duration: {
      type: Number,
      default: 2000
    },
    top: [String, Number],
    left: [String, Number],
    right: [String, Number],
    bottom: [String, Number],
    centerX: { type: Boolean, default: true },
    centerY: { type: Boolean, default: true },
    centerOffsetX: { type: Number, default: 0 },
    centerOffsetY: { type: Number, default: 0 }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    computedStyle () {
      const style = {}

      if (this.centerY) style.top = '50%'
      else if (this.top !== undefined) style.top = this.unit(this.top)
      else if (this.bottom !== undefined) style.bottom = this.unit(this.bottom)

      if (this.centerX) style.left = '50%'
      else if (this.left !== undefined) style.left = this.unit(this.left)
      else if (this.right !== undefined) style.right = this.unit(this.right)

      const transforms = []
      if (this.centerX) transforms.push(`translateX(${-50 + this.centerOffsetX / 100}%)`)
      if (this.centerY) transforms.push(`translateY(${-50 + this.centerOffsetY / 100}%)`)
      if (transforms.length > 0) style.transform = transforms.join(' ')

      return style
    }
  },
  methods: {
    unit (v) {
      return typeof v === 'number' ? `${v}px` : v
    },
    close () {
      this.visible = false
      this.$emit('close')
    }
  },
  mounted () {
    this.visible = true
    if (this.duration > 0) {
      setTimeout(this.close, this.duration)
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  @include flexXYcenter;
  position: absolute;
  min-height: 32px;
  padding: 6px 16px;
  border-radius: 6px;
  background-color: #000;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.16);
  box-sizing: border-box;
  color: #68BB0C;
  font-size: 13px;
  font-weight: 400;
  line-height: 120%;
  white-space: nowrap;
  z-index: 1000;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
